import React from "react";

import { Title, Margin, Text } from "~/components/elements";
import { Grid } from "@material-ui/core";
import { Link, useLocation } from "react-router-dom";

import * as S from "./styles";

export default function LegalInformationContent() {
  const location = useLocation();
  return (
    <Grid container justifyContent="space-between" align="initial">
      <S.ContentHolder>
        <Margin mb={2}>
          <Title emphasis as={1} level="2">
            Informações Legais
          </Title>
        </Margin>
        <Margin mb={2}>
          <Text as="strong">Termos Legais de Uso </Text>
          <Text as="2">
            Este website (“Website”) é fornecido a você mediante estes "Termos
            de Uso" , bem como quaisquer alterações ou complementos a eles
            (coletivamente denominados "Contrato") que poderão ser publicados
            por JNTL Consumer Health (Brazil) Ltda ou uma de suas empresas
            afiliadas (coletivamente, “Proprietário do Site,” "nós", "nos") de
            tempos em tempos. Seu uso deste Website ou de quaisquer serviços ou
            conteúdo previsto por meio do Website será considerado a constituir
            seu consentimento em legalmente se obrigar pelos termos e condições
            do Contrato, que serão exequíveis da mesma maneira como se você
            tivesse assinado o Contrato. Caso não deseje aceitar os termos e
            condições no Contrato, pedimos que você não acesse ou utilize o
            Website ou divulgue ou envie quaisquer materiais a respeito dele.
          </Text>
        </Margin>
        <Margin mb={2}>
          <Text as="strong">Público-Alvo do Website</Text>
          <Text>
            Este Website se destina a residentes do Brasil. Este Website não se
            destina a nenhuma pessoa com idade inferior a 18 anos.
          </Text>
        </Margin>
        <Margin mb={2}>
          <Text as="strong">Isenção de Responsabilidade de Informações</Text>
          <Text>
            AS INFORMAÇÕES, INCLUINDO A LEI, AVISO E RECOMENDAÇÕES SOBRE O
            WEBSITE, DESTINAM-SE UNICAMENTE COMO AUXÍLIO GERAL EDUCATIVO. NÃO
            VISA FORNECER ATENDIMENTO MÉDICO OU DE SAÚDE, NEM SER UTILIZADO PARA
            DIAGNÓSTICO OU TRATAMENTO MÉDICO, EM QUALQUER PROBLEMA INDIVIDUAL.
            TAMBÉM NÃO SE DESTINA COMO UM SUBSTITUTO POR ACONSELHAMENTO
            PROFISSIONAL E SERVIÇOS DE UM PRESTADOR DE SERVIÇOS DE SAÚDE
            QUALIFICADO FAMILIARIZADO COM SEUS FATOS ÚNICOS. SEMPRE BUSQUE A
            ORIENTAÇÃO DE SEU MÉDICO OU OUTRO PROVEDOR DE SERVIÇOS DE SAÚDE
            QUALIFICADO A RESPEITO DE QUALQUER CONDIÇÃO MÉDICA E ANTES DE
            INICIAR QUALQUER NOVO TRATAMENTO. O SEU USO DO SITE ESTÁ SUJEITO A
            OUTRAS RENÚNCIAS E RESSALVAS QUE POSSAM SURGIR POR TODO O WEBSITE.
          </Text>
          <Text>
            NÃO ASSUMIMOS NENHUMA RESPONSABILIDADE POR NENHUMA CONSEQUÊNCIA
            RELATIVA DIRETA OU INDIRETAMENTE A QUALQUER AÇÃO OU INAÇÃO QUE VOCÊ
            TOME COM BASE NAS INFORMAÇÕES, SERVIÇOS, OU OUTRO MATERIAL SOBRE O
            WEBSITE. ENQUANTO TENTAMOS MANTER AS INFORMAÇÕES NO WEBSITE
            PRECISAS, COMPLETAS E ATUALIZADAS, NÃO DAMOS NENHUMA GARANTA E NÃO
            SEREMOS RESPONSABILIZADOS POR NENHUM DANO OU PREJUÍZO COM RELAÇÃO À
            PRECISÃO, COMPLETUDE OU TEMPESTIVIDADE DAS INFORMAÇÕES SOBRE O
            WEBSITE.
          </Text>
        </Margin>
        <Margin mb={2}>
          <Text as="strong">Propriedade</Text>
          <Text>
            Você entende que o Website está disponível apenas para seu uso
            pessoal e não comercial. Você concorda que o Website é de
            propriedade do Proprietário do Site; incluindo todos os direitos de
            propriedade intelectual sobre ele e que você não tem o direito de
            utilizá-lo, a não ser segundo o estipulado nestes Termos de Uso. Nós
            não somos responsáveis por nenhum dano ou prejuízo que você sofra em
            relação a qualquer uso que faça do Website para quaisquer fins
            comerciais ou outros fins não autorizados segundo estes Termos de
            Uso. Reservamo-nos o direito de se recusar ou concluir o acesso ao
            Website a nosso critério. O Website é prestado livre de custo e
            baseando-se no fato de que não temos nenhuma obrigação em prestar
            quaisquer serviços de manutenção ou suporte em relação a ele e nós
            não somos responsáveis por nenhuma perda ou dano que você possa
            sofrer como resultado de qualquer falha em manter ou atualizar o
            Website. Você não poderá copiar, alterar ou reutilizar o Website,
            quaisquer atualizações a ele ou em qualquer parte dele, incluindo o
            software incluído nele.
          </Text>
          <Text>
            Você não poderá copiar, alterar ou reutilizar o Website, quaisquer
            atualizações a ele ou em qualquer parte dele, incluindo o software
            incluído nele.
          </Text>
          <Text>
            Você poderá utilizar este Website apenas para os fins legais e em
            conformidade com estes Termos de Uso. Você recebe uma licença não
            exclusiva, intransferível, revogável, limitada para visualizar,
            imprimir e distribuir o conteúdo recuperado do Website para seus
            fins pessoais e não comerciais, contanto que você não retire nem
            oculte o aviso de copyright ou outros avisos exibidos no conteúdo.
            Você não poderá copiar, reimprimir, modificar, exibir, executar,
            traduzir, distribuir, adaptar, difundir, comunicar ao público por
            meio de telecomunicação, circular ou vender o conteúdo recuperado do
            Website de forma alguma, para qualquer uso comercial ou fornecê-lo a
            qualquer fonte comercial, incluindo outros websites, sem a prévia
            permissão por escrito do Proprietário do Site.
          </Text>
          <Text>
            Além disso, você concorda em não: (i) utilizar este Website de
            nenhuma maneira que poderia desabilitar, sobrecarregar, danificar ou
            prejudicar este Website, ou interferir em qualquer outro uso deste
            Website, incluindo, qualquer habilidade do usuário de empreender em
            atividades em tempo real por todo este Website; (ii) utilizar
            qualquer robô, mecanismo ou outro dispositivo automático, processo
            ou meio para acessar este Website para qualquer finalidade,
            incluindo raspar, efetuar a mineração de dados, monitorar ou copiar
            qualquer material sobre este Website; (iii) utilizar qualquer
            processo manual para monitorar ou copiar qualquer material neste
            Website, ou empreender em qualquer outro processo não autorizado sem
            o consentimento expresso prévio e por escrito do Proprietário do
            Site; (iv) de outra maneira utilizar qualquer dispositivo, software
            ou rotina que interfira no funcionamento adequado deste Website; ou
            (v) de outra maneira tentar interferir com a operação adequada deste
            Website.
          </Text>
          <Text>
            Reservamo-nos todos os direitos não expressamente concedidos a você.{" "}
          </Text>
        </Margin>
        <Margin mb={2}>
          <Text as="strong">Sua Conta e Senha</Text>
          <Text>
            Quando você primeiramente registrar o uso do Website, você poderá
            ser motivado a criar uma senha. Você deverá manter sua senha em
            sigilo e não entregá-la a nenhuma outra pessoa nem deixar que
            utilizem sua conta. Você não deverá utilizar a senha ou a conta de
            nenhuma outra pessoa. Você deverá nos informar imediatamente caso
            você suspeite de qualquer uso não autorizado ou acesso a sua senha
            ou conta. Não seremos responsabilizados se você sofrer qualquer dano
            ou prejuízo em razão de não manter sua senha em sigilo, caso deixe
            alguém utilizar sua conta, caso você utilize a conta ou senha de
            alguém, ou caso tome ciência ou suspeite do uso não autorizado de
            sua senha ou conta, mas não nos diga prontamente.{" "}
          </Text>
        </Margin>

        <Margin mb={2}>
          <Text as="strong">
            Privacidade e Consentimento para o Uso de Dados
          </Text>
          <Text>
            As informações que obtemos pelo seu uso do Website, seja por meio do
            processo de registro ou de outra maneira, estão sujeitas a nossa
            Política de Privacidade. Nossa{" "}
            <Link to={`/politica-de-privacidade${location.search}`}>Política de Privacidade</Link>{" "}
            trata de nossa coleta e uso dos dados que você fornecer para nós,
            incluindo seus direitos relativos a essas informações
          </Text>
        </Margin>
        <Margin mb={2}>
          <Text as="strong">Comunicações Eletrônicas</Text>
          <Text>
            As informações comunicadas no Website constituem uma comunicação
            eletrônica. Quando você se comunica conosco por todo o Website ou
            por outros formulários de mídia eletrônica, tais como e-mail, você
            está se comunicando conosco eletronicamente. Você concorda que
            podemos nos comunicar eletronicamente, sujeitos às leis locais de
            privacidade, e que essa comunicação, assim como os avisos,
            divulgações, contratos, e outras comunicações que fornecemos a você
            eletronicamente, são equivalentes às comunicações por escrito e
            terão o mesmo vigor e efeito, como se estivessem por escrito e fosse
            assinado pela parte que envia a comunicação.
          </Text>
        </Margin>
        <Margin mb={2}>
          <Text as="strong">Submissões do Usuário </Text>
          <Text>
            Criamos ou podemos criar no futuro certas áreas, tais como quadros
            de mensagens e salas de bate papo, dentro do Website, nos quais os
            membros podem carregar e compartilhar seus pensamentos, comentários,
            análises de produto, fotos, vídeos e similares com outros membros
            (coletivamente, “Fóruns”). Esses Fóruns poderão estar disponíveis
            apenas para os membros registrados do Website. Para ajudar a
            garantir que o texto, gráficos, softwares, música, sons,
            fotografias, vídeos, mensagens, posts, dados, informações ou outros
            materiais postados por usuários (coletivamente, "Conteúdo do
            Usuário") beneficiem toda uma comunidade, estabelecemos algumas
            regras básicas para que todos possam seguir.
          </Text>
          <Text>
            Além disso, se um Fórum estiver estipulado dentro do Website, poderá
            permitir que os usuários publiquem perguntas a serem respondidas por
            especialistas contratados por nós. Quando aplicável, esses
            especialistas são pagos por nós pelo seu tempo para responder às
            perguntas dos membros, mas as opiniões que expressam são suas
            próprias opiniões. Estamos dando acesso aos especialistas e sua
            orientação no Fórum unicamente como um serviço informativo e
            educacional aos membros do Website.
          </Text>
          <Text>
            Nossa política para este Website é rever o Conteúdo do Usuário,
            contanto que prático, antes ou após a publicação desse Conteúdo do
            Usuário. Pré-moderação significa que o Conteúdo do Usuário não será
            publicado no Fórum e não poderá ser acessado ou visualizado por
            outros membros do Website até que o tenhamos revisado e determinado
            que o Conteúdo do Usuário é adequado para publicação no Fórum. Esse
            processo também significa que o Conteúdo do Usuário encaminhado para
            publicação não será postado em tempo real e pode nunca ser postado
            se determinarmos que é inadequado para o Website. Pós-moderação
            significa que o Conteúdo do Usuário será revisto por nós assim que
            já tiver sido postado no Website. O Conteúdo do Usuário pós-moderado
            que o Proprietário do Site determina não cumprir com estes Termos ou
            for de outra maneira inadequado para o Website será retirado do
            Website, sem aviso prévio ao Usuário.
          </Text>
          <Text>
            O Conteúdo do Usuário deve ser apropriado para o Fórum. Sem limitar
            os motivos pelos quais um Conteúdo do Usuário pode ser rejeitado por
            nós, nós podemos rejeitar, editar ou remover qualquer Conteúdo do
            Usuário que não cumpra nenhuma Diretriz da Comunidade que
            fornecemos, a qual você deve ler antes de publicar qualquer Conteúdo
            do Usuário no Website.
          </Text>
          <Text>
            Ao enviar o Conteúdo do Usuário para publicação em um Fórum, você
            também (1) confirma que tem o direito de publicar ou transmitir o
            Conteúdo do Usuário; (2) concorda que você é unicamente responsável
            por todo o Conteúdo do Usuário que envia para publicação; e (3)
            concede ao Proprietário do Site e a suas entidades afiliadas uma
            licença irrevogável, mundial, não exclusiva, perpétua, integralmente
            sublicenciável, transferível, e direito de royalty livre sobre o
            uso, seu Conteúdo do Usuário de qualquer maneira no Website e em
            qualquer outro Website detido ou operado pelo Proprietário do Site
            ou por suas afiliadas (assim como em quaisquer outros sites de mídia
            social associados ao Proprietário do Site ou a suas afiliadas).
          </Text>
          <Text>
            <Text as="strong">
              Estamos livres para utilizar quaisquer ideias, conceitos,
              know-how, ou técnicas contidas em ou derivadas de qualquer
              Conteúdo do Usuário para qualquer finalidade, incluindo o
              desenvolvimento, fabricação e produtos de marketing. Por esse
              motivo, não envie nem nos submeta ideias, sugestões ou materiais
              que você deseja que sejam mantidos em sigilo ou pelos quais você
              espera receber algum tipo de remuneração. Você não terá nenhuma
              reclamação contra nós com relação a qualquer uso ou falta de
              utilização do Conteúdo do Usuário.
            </Text>{" "}
            Ao enviar o Conteúdo do Usuário, você entende que teremos o direito,
            mas não a obrigação, de utilizar, exibir e publicar seu nome,
            fotografia, imagem, voz, desempenho, informação biográfica e/ou
            declarações, por todo o mundo, pela duração do Website e em qualquer
            Website afiliado ou sucessor ou canais de mídia social detidos ou
            operados por nós ou por nossas afiliadas. Caso façamos uso de
            qualquer um desses direitos, você entende e concorda que você não
            receberá nenhuma outra contraprestação, pagamento, notificação ou
            crédito, nem terá qualquer aprovação sobre como o Proprietário do
            Site os utiliza.
          </Text>
          <Text>
            Você reconhece que os Fóruns contêm as opiniões e visões de outros
            usuários. Você ainda reconhece que nós não somos responsáveis pela
            precisão de qualquer Conteúdo do Usuário no Website. Você entende e
            concorda que todo o Conteúdo do Usuário é de responsabilidade única
            da pessoa que postou o Conteúdo. Você entende e concorda que
            avaliará e arcará com todos os riscos associados ao uso de qualquer
            Conteúdo do Usuário, incluindo qualquer confiança quanto à precisão,
            completude ou utilidade desse Conteúdo do Usuário.
          </Text>
          <Text>
            Nós reservamos o direito de descontinuar, a qualquer momento,
            temporária ou permanentemente, sua capacidade de carregar o Conteúdo
            do Usuário e/ou sua capacidade de acessar o Conteúdo do Usuário com
            ou sem aviso, a nosso absoluto critério. Você concorda que não nos
            responsabilizamos por você ou qualquer terceiro no caso de qualquer
            suspensão ou descontinuidade de aceite do Conteúdo do Usuário.
          </Text>
          <Text>
            Lembre-se de que todo o Conteúdo do Usuário que você submete ao
            Website por meio de um dispositivo móvel será armazenado nesse
            dispositivo móvel. A segurança e proteção de seu dispositivo móvel,
            bem como as informações e materiais contidos nele, e qualquer senha
            que você utiliza em seu dispositivo para acessar o Website são de
            sua única responsabilidade.
          </Text>
        </Margin>
        <Margin mb={2}>
          <Text as="strong">Armazenamento do Conteúdo do Usuário </Text>
          <Text>
            Podemos impor uma quantidade máxima de armazenamento para o Conteúdo
            do Usuário sobre o Website. Nós não somos responsáveis por nenhum
            prejuízo nem dano que você possa sofrer como resultado de qualquer
            exclusão ou falha em armazenar quaisquer mensagens, comunicações ou
            outro Conteúdo do Usuário associado à manutenção da quantidade
            máxima de armazenamento.
          </Text>
        </Margin>
        <Margin mb={2}>
          <Text as="strong">Termos Adicionais</Text>
          <Text>
            Os termos adicionais podem reger certas características ou conteúdo
            sobre o Website, tais como ofertas, sorteios, competições, concursos
            e bolões. Ao participar em qualquer atividade no Website regida por
            termos adicionais, tais como um sorteio, competição, concurso ou
            bolão com Regras Oficiais, você concorda que estará sujeito a esses
            termos adicionais além destes Termos de Uso.
          </Text>
        </Margin>
        <Margin mb={2}>
          <Text as="strong">
            Renúncia de Garantias com relação ao Uso do Website
          </Text>
          <Text>
            O WEBSITE É FORNECIDO “NO ESTADO EM QUE SE ENCONTRA” E “DA FORMA
            DISPONIBILIZADA”. EXCETO SEGUNDO O ESPECIFICAMENTE PREVISTO NESTE
            INSTRUMENTO, À MÁXIMA EXTENSÃO PERMITIDA POR LEI APLICÁVEL, O
            PROPRIETÁRIO DO SITE EXPRESSAMENTE RENUNCIA A TODAS AS GARANTIAS DE
            QUALQUER TIPO, SEJAM EXPRESSAS, LEGAIS OU IMPLÍCITAS, INCLUINDO,
            ENTRE OUTROS, QUAISQUER GARANTIAS DE COMERCIALIZAÇÃO, ADEQUAÇÃO PARA
            UMA FINALIDADE ESPECÍFICA E NÃO INFRAÇÃO. O PROPRIETÁRIO DO SITE NÃO
            FAZ NENHUMA GARANTIA DE QUE O WEBSITE ATENDERÁ A SEUS REQUISITOS, OU
            O ACESSO AO WEBSITE SERÁ ININTERRUPTO, EM TEMPO HÁBIL, GARANTINDO OU
            ESTANDO ISENTO DE ERROS OU DEFEITOS, SE HOUVER, E SERÁ CORRIGIDO. O
            PROPRIETÁRIO DO SITE NÃO FAZ NENHUMA GARANTIA QUANTO AOS RESULTADOS
            QUE POSSAM SER OBTIDOS DO USO DO WEBSITE OU QUANTO À ADEQUAÇÃO,
            QUALIDADE OU CONFIABILIDADE DE QUALQUER INFORMAÇÃO CONTIDA POR TODO
            O WEBSITE. VOCÊ ENTENDE E CONCORDA QUE QUALQUER MATERIAL E/OU DADOS
            BAIXADOS POR DOWNLOAD OU DE OUTRA MANEIRA OBTIDOS PELO USO DO
            WEBSITE SEJAM UTILIZADOS POR SUA CONTA E RISCO E QUE VOCÊ SERÁ
            UNICAMENTE RESPONSÁVEL POR QUALQUER DANO EM SEUS SISTEMAS DE
            COMPUTADOR OU PERDA DE DADOS QUE RESULTEM DO DOWNLOAD DESSE MATERIAL
            E/OU DADOS. NENHUM CONSELHO OU INFORMAÇÃO, VERBAL OU POR ESCRITO,
            OBTIDO POR VOCÊ DO PROPRIETÁRIO DO SITE OU POR TODO O WEBSITE CRIARÁ
            QUALQUER GARANTIA NÃO EXPRESSAMENTE FEITA NESTE INSTRUMENTO.
          </Text>
        </Margin>
        <Margin mb={2}>
          <Text as="strong">Limitações de Responsabilidade </Text>
          <Text>
            VOCÊ EXPRESSAMENTE ENTENDE E CONCORDA QUE SOB NENHUMA CIRCUNSTÂNCIA
            O PROPRIETÁRIO DO SITE, SUAS AFILIADAS E QUALQUER UM DE SEUS
            RESPECTIVOS DIRETORES, EXECUTIVOS, FUNCIONÁRIOS, AGENTES,
            MANDATÁRIOS OU OUTROS REPRESENTANTES SERÃO RESPONSABILIZADOS POR
            DANOS DIRETOS, INDIRETOS, ESPECIAIS, INCIDENTAIS, CONSEQUENCIAIS,
            PUNITIVOS OU AGRAVADOS, INCLUINDO, ENTRE OUTROS, QUALQUER PERDA DE
            USO, PERDA DE RECEITA, LUCROS CESSANTES OU GANHOS, PERDA DE DADOS,
            PERDA DE FUNDO DE COMÉRCIO, CUSTO DE AQUISIÇÃO DE SERVIÇOS
            SUBSTITUTOS, OU QUAISQUER OUTROS DANOS INDIRETOS, ESPECIAIS OU
            CONSEQUENCIAIS, QUE SEJAM CAUSADOS, E SOBRE QUALQUER TEORIA DE
            RESPONSABILIDADE, SEJA POR QUEBRA DE CONTRATO, ATO ILÍCITO
            (INCLUINDO NEGLIGÊNCIA E RESPONSABILIDADE ESTRITA), OU DE OUTRA
            MANEIRA RESULTANTE (1) DO USO OU DA INCAPACIDADE DE UTILIZAR O
            WEBSITE; (2) DO CUSTO DE AQUISIÇÃO DE SERVIÇOS SUBSTITUTOS, ITENS OU
            WEBSITES; (3) DO ACESSO NÃO AUTORIZADO OU ALTERAÇÃO EM SUAS
            TRANSMISSÕES OU DADOS (INCLUINDO INFORMAÇÕES PESSOAIS); (4) AS
            DECLARAÇÕES OU CONDUTA DE QUALQUER TERCEIRO SOBRE O WEBSITE; OU (5)
            QUALQUER OUTRA QUESTÃO RELATIVA AO WEBSITE. ESSAS LIMITAÇÕES SE
            APLICARÃO SE O PROPRIETÁRIO DO SITE FOI OU NÃO AVISADO DA
            POSSIBILIDADE DESSES DANOS E NÃO OBSTANTE QUALQUER FALHA DA
            FINALIDADE ESSENCIAL DE QUALQUER REMÉDIO LIMITADO. ESSA EXCLUSÃO DE
            RESPONSABILIDADE SE APLICARÁ À MÁXIMA EXTENSÃO PERMITIDA POR LEIS
            APLICÁVEIS.
          </Text>
        </Margin>
        <Margin mb={2}>
          <Text as="strong">Avisos de Marca Registrada </Text>
          <Text>
            As marcas registradas e nomes de marca exibidos neste Website são de
            propriedade do Proprietário do Site, suas afiliadas ou proprietários
            terceiros. Você não poderá utilizar ou exibir quaisquer marcas
            registradas ou marcas de serviço detidos pelo Proprietário do Site
            sem nosso prévio consentimento por escrito. Você não poderá utilizar
            nem exibir quaisquer outras marcas registradas ou marcas de serviço
            exibidos neste Website sem a permissão de seus proprietários.
          </Text>
        </Margin>
        <Margin mb={2}>
          <Text as="strong">
            Aviso e Procedimento para Fazer Reclamações de Infração de Copyright
          </Text>
          <Text>
            Pedimos que nossos usuários respeitem a propriedade intelectual de
            outros. Nos termos da Lei de Direitos Autorais “LEI Nº 9.610, DE 19
            DE FEVEREIRO DE 1998”, lei de proteção da propriedade intelectual de
            programa de computador “LEI Nº 9.609 , DE 19 DE FEVEREIRO DE 1998”,
            lei direitos e obrigações relativos à propriedade industrial “LEI Nº
            9.279, DE 14 DE MAIO DE 1996”, designamos um agente para receber os
            avisos de infração de copyright reclamado que podem ser obtidos por
            meio da seção “Fale Conosco” deste website (localizada aqui:{" "}
            <a
              target="_blank"
              without
              rel="noopener noreferrer"
              href="https://www.jnjbrasil.com.br/fale-conosco-landing"
            >
              https://www.jnjbrasil.com.br/fale-conosco-landing
            </a>
            ) se preenchido para o processo delineado nos parágrafos 1-6 infra,
            pelos números de telefone listados em nossa página de Fale Conosco
            e/ou por meio de uma carta com os 6 (seis) tipos de informação
            enviados para o seguinte endereço: Reclamação de Copyright aos
            cuidados do Centro de Atendimento ao Consumidor : JNTL Consumer
            Health (Brazil) Ltda. Central de Relacionamento com Consumidores:
            Av. Pres. Juscelino Kubitschek, 2041 Complexo JK - Torre B - 6º
            andar São Paulo (SP) CEP: 04543-011. Caso você acredite de boa-fé
            que seu trabalho foi copiado de modo que constitua uma infração de
            copyright, por favor, forneça a nosso Agente de Copyright as
            seguintes informações por todo o processo descrito abaixo:
          </Text>
          <Text>
            1. Uma listagem do Primeiro Nome e Sobrenome corretos, Endereço de
            E-mail e Endereço Físico da pessoa autorizada a agir em nome do
            proprietário da participação do copyright;
            <br />
            2. Ao utilizar a página “Fale Conosco”, seleção da opção
            “Preocupação ou Reclamação” segundo a seção “Assunto do E-mail” do
            formulário.
            <br />
            3. Uma descrição do trabalho com copyright que você reclama ter sido
            infringido com uma assinatura original. Ao enviar por meio de nosso
            formulário “Fale Conosco”, forneça essa informação na seção
            “Perguntas ou Comentários” do formulário “Fale Conosco”, incluindo
            uma assinatura eletrônica ao final de sua descrição (por exemplo,
            /nome/);
            <br />
            4. Uma descrição de onde o material que você reclama está
            infringindo está localizado no Website (incluindo um link/URL,
            específico, quando possível);
            <br />
            5. Uma declaração sua de que você possui uma crença de boa-fé de que
            o uso disputado não é autorizado pelo proprietário do copyright, seu
            agente ou lei, a ser incluído na reclamação, ou ao utilizar o
            formulário, a ser incluído na seção “Perguntas ou Comentários” do
            formulário “Fale Conosco”; e
            <br />
            6. Uma declaração sua, feita sob pena de perjúrio, que as
            informações acima em seu aviso são precisas e que você é o
            proprietário do copyright ou que está autorizado a agir em nome do
            proprietário do copyright, a ser incluído na carta de reclamação, ou
            se usar o formulário, a ser incluído na seção “Perguntas ou
            Comentários” do formulário “Fale Conosco” (que conterá sua
            “assinatura eletrônica” da forma exigida no item 3 (três) acima).
            <br />
          </Text>
          <Text>
            Ao receber a notificação contendo todas as informações delineadas
            nos itens 1 a 6 acima:
            <br />
            1. Nós removeremos ou desabilitaremos o acesso ao material suposto
            como infrator;
            <br />
            2. Nós encaminharemos a notificação para esse suposto infrator
            ("Assinante"); e
            <br />
            3. Nós tomaremos as medidas razoáveis para prontamente notificar o
            Assinante de que removeu ou desabilitou o acesso ao material.
            <br />
          </Text>
        </Margin>
        <Margin mb={2}>
          <Text as="strong">Modificação ou Suspensão do Website</Text>
          <Text>
            Envidaremos os esforços razoáveis para disponibilizar o Website, mas
            de tempos em tempos precisaremos interromper, restringir, modificar
            ou descontinuar, temporária ou permanentemente o Website ou partes
            dele sem aviso. Não seremos responsáveis por nenhum dano ou prejuízo
            que você possa sofrer como resultado dessas ações.
          </Text>
        </Margin>
        <Margin mb={2}>
          <Text as="strong">Rescisão</Text>
          <Text>
            Podemos, a qualquer momento, terminar seu uso ou acesso ao Website e
            poderemos excluir todo ou qualquer Conteúdo do Usuário sem aviso
            prévio se tivermos um bom motivo para isso que inclua qualquer
            quebra por você destes Termos de Uso e a Diretriz da Comunidade. Não
            seremos responsáveis por nenhum prejuízo ou dano que você possa
            sofrer como resultado do término de seu uso do Website nessas
            circunstâncias. Em caso de qualquer rescisão, você deverá suspender
            o uso do Website e você concorda que as disposições do Contrato
            sobre Propriedade, Avisos de Marca Registrada, Indenização, Renúncia
            ou Garantias, Limitações de Responsabilidade e Lei Aplicável
            sobreviverão a qualquer término.
          </Text>
        </Margin>
        <Margin mb={2}>
          <Text as="strong">Links a Sites de Terceiros</Text>
          <Text>
            Este Website poderá conter links ou referências a websites de
            terceiros. Esses links são apresentados apenas para fins de
            conveniência. Nenhum endosso de quaisquer produtos de terceiro,
            serviços ou informações é expresso ou implícito por qualquer
            informação, material ou conteúdo de qualquer terceiro contido,
            referido, incluído ou ligado a este Website. Quaisquer informações,
            dados, opiniões, recomendações, produtos ou serviços oferecidos por
            esses terceiros por links a outros websites ou de outra maneira
            disponibilizados por seus websites servem unicamente para esses
            terceiros e não ao Proprietário do Site. Seu uso desses websites de
            terceiro estão sujeitos aos Termos de Uso e às políticas de
            privacidade desses websites.
          </Text>
        </Margin>
        <Margin mb={2}>
          <Text as="strong">Indenização</Text>
          <Text>
            Você concorda em indenizar e isentar o Proprietário do Site e suas
            afiliadas e seus respectivos diretores, executivos, funcionários,
            agentes ou outros representantes de todas as reclamações,
            responsabilidade, danos e despesas, incluindo, sem limitação, todos
            os honorários advocatícios e custas decorrentes de ou relativos a
            (a) sua quebra destes Termos de Uso; (b) seu uso deste Website
            incluindo, entre outros, transmissão ou colocação de informações ou
            material por você neste Website; e (c) qualquer reclamação ou
            alegação que qualquer Conteúdo do Usuário seu infringe a propriedade
            intelectual ou outros direitos proprietários, ou direitos de
            privacidade, de qualquer terceiro.
          </Text>
        </Margin>
        <Margin mb={2}>
          <Text as="strong">Modificações a estes Termos</Text>
          <Text>
            Podemos fazer mudanças aos Termos de Uso de tempos em tempos a nosso
            absoluto critério, ao atualizar estes Termos de Uso neste Website,
            especificando a data efetiva da nova versão dos Termos de Uso. A
            data da “Última Modificação” acima destes Termos de Uso indicará
            quando as últimas alterações foram feitas. Seu uso contínuo do
            Website após a publicação de uma nova versão dos Termos de Uso
            constitui seu aceite a qualquer uma dessas alterações. Assim, sempre
            que você visitar este Website, você deve verificar se uma nova
            versão do Contrato foi publicada.
          </Text>
        </Margin>
        <Margin mb={2}>
          <Text as="strong">Informações de Contato</Text>
          <Text>
            Se você tiver alguma pergunta ou preocupação com relação a estes
            Termos de Uso ou do Website, você poderá falar conosco da forma
            identificada na Política de Privacidade ou na seção “Fale Conosco”
            deste Website.
          </Text>
        </Margin>
        <Margin mb={2}>
          <Text as="strong">Interdependência do Contrato</Text>
          <Text>
            Caso qualquer parte ou disposição destes Termos de Uso for
            considerada ilegal, inválida, nula, sem efeito ou inexequível, essa
            parte será considerada isolada destes Termos de Uso e não afetará a
            validade e exequibilidade de quaisquer disposições remanescentes.
          </Text>
        </Margin>
        <Margin mb={2}>
          <Text as="strong">Sobrevivência</Text>
          <Text>
            Todas as Seções sobreviverão à rescisão do direito de uso do
            Website. Direito Aplicável e Jurisdição
          </Text>
        </Margin>
        <Margin mb={2}>
          <Text as="strong">Direito Aplicável e Jurisdição</Text>
          <Text>
            As informações sobre o Website se destinam apenas para uso pelos
            residentes do Brasil. Outros países podem ter leis, requisitos
            regulatórios ou práticas médicas diferentes daqueles contidos no
            Brasil. O Contrato e a resolução de qualquer conflito com relação ao
            Contrato, Website, ou a itens que você adquire por todo o Website, e
            quaisquer obrigações não contratuais decorrentes destes ou em
            relação a estes Termos de Uso, serão regidos e interpretados em
            conformidade com as leis brasileiras, sem conferir efeito a
            quaisquer princípios de conflitos da lei. Qualquer ação legal ou
            processo entre o Proprietário do Site e você com relação ao Contrato
            será exclusivamente proposto em um tribunal de jurisdição competente
            localizado em São Paulo-SP, Brasil, e você concorda em se submeter à
            jurisdição pessoal e exclusiva desses tribunais.
          </Text>
        </Margin>
      </S.ContentHolder>
    </Grid>
  );
}
